// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2AYAo","large":"styles_large__x19FG"};